var Autogrow = require('autogrow');
var DialogView = require('dialogview');
var HistoryCompletion = require('historycompletion');
var TabCompletion = require('tabcompletion');
var FileWrapper = require('filewrapper');
var PastebinView = require('pastebinview');
var Keyboard = require('../../lib/keyboard.es6').default;
var urlUtil = require('../../lib/url.es6');
var utils = require('../../lib/util.es6');
var BufferFormatter = require('bufferformatter');


var BufferInputView = Backbone.View.extend({
    tagName: 'form',
    className: 'input',
    input: null,
    events: {
        'submit': 'submit',
        'keydown textarea': 'keyDown',
        'focus textarea': 'onFocus',
        'blur textarea': 'onBlur',
        'input textarea': 'onInput',
        'keyup textarea': 'onInput',
        'update textarea': 'onInput',
        'paste textarea': 'onPaste'
    },
    initialize: function (options) {
        this.focused = false;
        this.formatter = new BufferFormatter(this.model);
        this.model.bind('pastePrompt', this.pastePrompt, this);
    },
    onFocus: function () {
        this.focused = true;
        this.trigger('focus');
    },
    onBlur: function () {
        this.focused = false;
        this.trigger('blur');
    },
    isFocused: function () {
        return this.focused;
    },
    closeDialog: function (dialog) {
        var visibleInputs = $('input:focus, textarea:focus').filter(':visible');
        if (this.model.isSelected() && !visibleInputs.length) {
            this.focus();
        }
    },
    focusOnSelect: function () {
        if (this.model.isSelected()) {
            this.focus();
        } else {
            this.blur();
        }
    },
    submit: function (e) {
        try {
            this.say(this.val());
        } catch (exc) {
            // Catch errors so the form never submits
            debug.warn(exc);
        }
        return false;
    },
    keyDown: function (e) {
        return this.onKey(e);
    },
    onInput: function (e) {
        this.trigger('input', e);
        this.autogrow.resize();
    },
    collectPasteData: function (e) {
        var data = e.originalEvent.clipboardData || window.clipboardData;
        var files = [];
        var strings = [];
        var blobs = [];
        var complete = $.Deferred();
        if (data && data.items) {
            var itemLength = data.items.length;
            var checkResolve = function () {
                if (--itemLength === 0) {
                    if (!files.length) {
                        files = blobs;
                    }
                    complete.resolve(e, strings, files);
                }
            };
            _.each(data.items, function (item) {
                if (item.kind == 'string' && item.type == 'text/plain') {
                    item.getAsString(_.bind(function (value) {
                        if (value) {
                            var stringBlob = FileWrapper.blobFromDataURI(value);
                            if (stringBlob) {
                                blobs.push(stringBlob);
                            } else {
                                if (!urlUtil.urlParts(value)) {
                                    strings.push(value);
                                }
                            }
                        }
                        checkResolve();
                    }, this));
                } else if (item.kind == 'file') {
                    var blob = item.getAsFile();
                    if (blob) {
                        files.push(blob);
                    }
                    checkResolve();
                } else {
                    checkResolve();
                }
            }, this);
        } else {
            complete.reject();
        }
        return complete.promise();
    },
    pastePrompt: function () {
        this.sayPaste(this.val(), {manual: true});
    },
    onPaste: function (e) {
        this.collectPasteData(e).done(_.bind(this.handlePasteData, this));
    },
    handlePasteData: function (e, strings, files) {
        _.each(strings, function (value) {
            if ($(e.target).is(this.input)) {
                // value pasted already, suppress
            } else {
                this.insertAtCursor(value, true);
            }
        }, this);
        if (files.length) {
            var options = {
                files: files
            };
            this.model.trigger('upload', options);
        }
    },
    parseCommand: function (val) {
        return val.toLowerCase().match(/^\/(\w+)(?:$| (.*))/);
    },
    calculateLineLengthRemaining: function (val) {
        if (val === undefined) {
            val = this.val();
        }
        var parseCommand = this.parseCommand(val);

        var commandLen = 9;
        var textLen = utils.lengthInUtf8Bytes(val);
        if (parseCommand) {
            textLen = parseCommand[2] ? parseCommand[2].length : 0;
            switch (parseCommand[1]) {
            case 'me':
                commandLen = 18;
                break;
            case 'notice':
                commandLen = 8;
                break;
            default:
                return;
            }
        }
        var syntaxLen = 13;
        var totalLen = 512;
        var user = this.model.getUser();
        var nickLen = user.getNick().length;
        var maskLen = user.getHostMask().length;
        var targetLen = this.model.getName().length;
        var allowed = totalLen - syntaxLen - commandLen - nickLen - maskLen - targetLen;
        return allowed - textLen;
    },
    onKey: function (e) {
        this.trigger('key', e);
    },
    onEnter: function (e) {
        var val = this.val();
        if (Keyboard.isModifier(e)) {
            if (this.model.session.modifierMeEnabled()) {
                // cmd/ctrl-return
                if (val[0] == '/') {
                    // send as is if the first character's a slash
                    this.say('/' + val);
                } else {
                    // /me it
                    this.me(val);
                }
            } else {
                // add a new line
                this.insertAtCursor('\n');
            }
        } else if (e.ctrlKey || e.metaKey || e.altKey || e.shiftKey) {
            // any other modifier key: add a new line
            this.insertAtCursor('\n');
        } else {
            // bare return
            var parseCommand = this.parseCommand(val);
            if (parseCommand && parseCommand[1] == 'paste') {
                this.sayPaste(parseCommand[2], {
                    orig: val,
                    manual: true
                });
            } else if (parseCommand && parseCommand[1] == 'clear') {
                this.clear();
                this.model.trigger('clear');
            } else {
                var blob = FileWrapper.blobFromDataURI(val);
                if (blob) {
                    var options = {
                        dataURI: val,
                        files: [blob]
                    };
                    this.clear();
                    this.model.trigger('upload', options);
                } else {
                    // default: /say it
                    this.say(val);
                }
            }
        }
    },
    render: function () {
        var labelId = 'bufferInputView' + this.model.bid();
        if (this.model.isThread()) {
            labelId += 'Thead';
        }
        this.label = $('<label class="g">').text('New message input').attr('for', labelId);
        this.input = $('<textarea name="msg" rows="1"></textarea>').attr('id', labelId);
        $(this.el).append(this.label);
        $(this.el).append(this.input);

        // Autogrow
        this.autogrow = new Autogrow({
            el: this.input,
            minHeight: 20,
            manualDetect: true,
            manualTrigger: true
        });

        // History completion
        this.history = new HistoryCompletion({
            el: this.input,
            input: this,
            model: this.model,
        });

        // Tab completion
        this.tabComplete = new TabCompletion({
            el: this.input,
            model: this.model
        });
        this.tabComplete.bubble('completeCandidates', this);

        this.model.bind('selectedChange', this.focusOnSelect, this);
        this.model.bind('setInputText', this.setVal, this);
        this.model.bind('insertAtCursor', this.insertAtCursor, this);
        this.listenTo(this.model.session, 'buffersShown', this.focusOnSelect);
        this.focusOnSelect();

        this.model.bind('remove', this.remove, this);

        DialogView.bind('close', this.closeDialog, this);

        return this;
    },
    isValueSingleEmoji: function (value) {
        return emoji.strip_unified(emoji.replace_colons(value, true), true) === '';
    },
    say: function (message) {
        if (message) {
            if (this.shouldPaste(message)) {
                this.sayPaste(message);
            } else {
                var convertedMessage = message;
                var urlSplitParts = this.formatter.linker.splitTextOnUrls(message);
                var skinTone = this.model.session.getPref('skin-tone');
                var parts = _.map(urlSplitParts, function (part, index) {
                    if (part.url) {
                        var bits = this.formatter.linker.renderUrl(part.url);
                        if (bits) {
                            // Don't emojify urls
                            // Filter tracker params on http urls
                            if (
                                this.model.session.getPref('strip-url-trackers') &&
                                !this.formatter.linker.isCurrentUrl(bits.parts) &&
                                urlUtil.isLooseHttp(part.value)
                            ) {
                                var blockedQs = [
                                    // google analytics, filter globally
                                    'utm_source',
                                    'utm_medium',
                                    'utm_campaign',
                                    'utm_term',
                                    'utm_content',
                                    'utm_name',
                                    
                                    // domain specific but unique enough to
                                    // filter globally

                                    // ebay
                                    '_trkparms',
                                    '_trksid',
                                    // facebook
                                    'hc_ref',
                                    // bbc
                                    'ns_mchannel',
                                    'ns_source',
                                    'ns_campaign',
                                    'ns_linkname'
                                ];
                                // domain specific and could have false positives
                                if (urlUtil.matchYouTube(bits.parts)) {
                                    blockedQs = blockedQs.concat([
                                        'feature',
                                        'attr_tag'
                                    ]);
                                } else if (urlUtil.matchTwitter(bits.parts)) {
                                    blockedQs = blockedQs.concat([
                                        's',
                                        'ref_src',
                                        'ref_url'
                                    ]);
                                } else if (urlUtil.matchInstagram(bits.parts)) {
                                    blockedQs = blockedQs.concat([
                                        'igshid'
                                    ]);
                                }
                                // TODO more domain specific filters?
                                // amazon.com?ref (amazon.co.uk)
                                //           ?s
                                //           ?ie
                                //           ?qid
                                //           ?sr
                                //           ?keywords


                                var filteredUrlParts = urlUtil.filterSearchParams(
                                    urlUtil.urlParts(bits.parts.href), blockedQs
                                );
                                var filtered = false;
                                if (bits.parts.search != filteredUrlParts.search) {
                                    filtered = true;
                                }
                                var isAmp = urlUtil.isAmp(filteredUrlParts);
                                if (isAmp) {
                                    // Return cleaned + filtered
                                    var cleanedUrlParts = urlUtil.cleanAmpUrl(filteredUrlParts, true);
                                    return cleanedUrlParts.href;
                                } else if (filtered) {
                                    // Return filtered
                                    return filteredUrlParts.href;
                                } else {
                                    // Return unmodified
                                    return part.value;
                                }
                            } else {
                                return part.value;
                            }
                        }
                    }
                    if (this.model.session.getPref('emoji-disableconvert')) {
                        return part.value;
                    } else {
                        // Emojify plain text
                        return emoji.replace_colons(
                            part.value, true, skinTone
                        );
                    }
                }, this);
                convertedMessage = parts.join('');
                var replyMsgId, replyId;
                if (this.replyTarget) {
                    replyMsgId = this.replyTarget.getMsgId();
                    replyId = this.replyTarget.getReplyId();
                }
                if (this.model.isThread()) {
                    replyId = this.model.id;
                }
                if (replyMsgId && this.isValueReactionShortcut(message)) {
                    var substr = convertedMessage.substr(1);
                    if (this.isValueSingleEmoji(substr)) {
                        this.model.react(replyMsgId, substr);
                        this.model.pushInputHistory(convertedMessage, this.replyTarget);
                    } else {
                        return;
                    }
                } else if (replyId) {
                    this.model.reply(replyId, convertedMessage);
                    this.model.pushInputHistory(convertedMessage, this.replyTarget);
                } else {
                    this.model.say(convertedMessage, {
                        onCancel: _.bind(function () {
                            this.setVal(convertedMessage);
                        }, this)
                    });
                }
                this.clear();
            }
        }
    },
    shouldPaste: function (message) {
        var m = message.trim();
        return this.model.session.shouldPromptPastebins() && (
            m.indexOf('\n') !== -1 ||
            m.length > PastebinView.MESSAGE_LENGTH_TRIGGER
        );
    },
    sayPaste: function (message, options) {
        options = options || {};
        this.clear();
        this.model.session.trigger(
            'pasteConfirm', this.model, {
                contents: message,
                manual: options.manual
            }, _.bind(function () {
                this.setVal(options.orig || message);
            }, this)
        );
    },
    clear: function () {
        this.model.trigger('clearReplyHighlight');
        this.setVal('');
        this.tabComplete.clear();
    },
    me: function (message) {
        if (message) {
            if (this.shouldPaste(message)) {
                this.sayPaste(message);
            } else {
                this.say('/me ' + message);
            }
        }
    },
    insertAtCursor: function (value, focus) {
        var currentValue = this.val();
        var cursorRange = this.input.cursorRange();
        var chars = currentValue.split('');
        chars.splice(cursorRange.start, cursorRange.end - cursorRange.start, value);
        this.setVal(chars.join(''));
        this.input.cursorRange(cursorRange.start + value.length);
        if (focus) {
            this.focus();
        }
        return this;
    },
    isGrown: function () {
        return this.autogrow.isGrown();
    },
    val: function () {
        return this.input.val();
    },
    setVal: function (value) {
        this.input.val(value);
        this.onInput();
    },
    isSlashCommand: function (val) {
        if (val === undefined) {
            val = this.val();
        }
        return val.indexOf('/') === 0;
    },
    isValueReactionShortcut: function (value) {
        var reactionShortcut = '+:';
        return value.indexOf(reactionShortcut) === 0;
    },
    isReactionShortcut: function () {
        return this.isValueReactionShortcut(this.val());
    },
    blur: function () {
        if (this.isFocused()) {
            this.input.blur();
        }
    },
    focus: function () {
        if (!this.isFocused() && this.input.is(':visible')) {
            this.input.focus();
        }
    }
});


module.exports = BufferInputView;



//////////////////
// WEBPACK FOOTER
// ./app/src/view/model/bufferinputview.js
// module id = +laS
// module chunks = 1